module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingClans/components/Paginator/images/paginator-controls.31476b38.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/Paginator/images/paginator-controls.png
// module id = 3132
// module chunks = 11